import React, { useState } from "react"
import TextTruncate from "./textTruncate";
import { Row, Col, Form, FormControl, Table, Button, OverlayTrigger, Popover, Modal, ModalHeader, ModalBody, ModalFooter } from "react-bootstrap";
import PdfIFrame from "./PdfIFrame";
import PdfViewer from "./PdfView";
import "../../components/scss/document.scss"
const DocumentShow = (props) => {
  const {document, module} = props
  const [showDoc, setShowdoc] = useState(false)
  const [fileType, setFileType] = useState((""))


  return (
    <>
           {module && <p className="align1Individual align_lowerboxIndividual">Attached Files</p>} 
            {document && document.map(doc => (<div className="align_4_dataIndividual deleteIndividual" onClick={() => {
                setShowdoc(doc.docURL);
                const url = new URL(doc.docURL);
                const fileExtension = url.pathname.split('.').pop().toLowerCase();
                const extension = doc?.fileType ? doc?.fileType : fileExtension
                setFileType(extension)
            }
            }>
                <span className="hoverIndividual ms-2">{(doc.docType !== "PreRegRuleLog" && doc.docType !== "PostRegRuleLog") && <TextTruncate text={doc.docName} length={23} />}</span>
            </div>
            ))}
            {/* <div class="deleteIndividual"><span class="hoverIndividual">{policyDetailCookie.Policy_Document}</span></div> */}
        {showDoc !== '' ? (<Modal
                        size="lg"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        show={showDoc}
                        onHide={() => setShowdoc(false)}
                    >
                        <Modal.Header style={{zIndex: 100 }}>
                            <Modal.Title id="contained-modal-title-vcenter">
                                {props.heading? props.heading : 'Attached Files'}
                                
                            </Modal.Title>
                            <span onClick={() => { setShowdoc(false) }} className="custom-close" style={{ marginTop: "-20px", marginRight: "-10px" }}>&times;</span>
                        </Modal.Header>
                        <Modal.Body>
                                {fileType?.toLowerCase() === "pdf" ? (                              
                                       showDoc && <PdfViewer docUrl={showDoc}/>
                                ) : fileType == "mp4" ? (
                                    <video className="ms-5 ps-2 mt-0 mb-5" autoPlay={false} width="600" height="350" controls>
                                        <source src={showDoc} type="video/mp4" />
                                    </video>
                                ) : (
                                    <div className="vertical-alignment">
                                        <a className="image-wrapper">
                                            <img src={showDoc} alt="Success" className="responsive-image"  />
                                        </a>
                                    </div>
                                )}
                        </Modal.Body>
                    </Modal>) : null}  
    </>
  )
};

export default DocumentShow;